import { responsiveFont } from './responsiveFont';
/**
 * Get responsive CSS for the `label` font style.
 * @beta Should not be used in production, as this might change.
 */
export function responsiveLabelFont(props) {
    return responsiveFont('label', props);
}
//# sourceMappingURL=labelFontStyle.js.map